/**
 * Runtime Environment Provider
 * 运行时环境变量提供者 - 纯客户端实现
 * 从 window.__ENV__ 或 import.meta.env 获取配置
 */

import { createContext, useContext, type ReactNode } from 'react'
import { getEnvConfig, type EnvConfig } from '@/lib/runtime-env'

const EnvContext = createContext<EnvConfig>(getEnvConfig())

export function EnvProvider({ children }: { children: ReactNode }) {
  const env = getEnvConfig()

  return <EnvContext.Provider value={env}>{children}</EnvContext.Provider>
}

/**
 * Hook to access runtime environment variables
 * 在任何组件中使用此 hook 访问环境变量
 */
export function useEnv() {
  const context = useContext(EnvContext)
  if (!context) {
    throw new Error('useEnv must be used within EnvProvider')
  }
  return context
}

// 导出配置获取函数供 API 客户端使用
export { getEnvConfig }
